/**
 * Navbar - 顶部导航栏组件
 * options:
 *   brand  - string 或 { text, href }
 *   links  - [{ key?, text, href }]
 *   activeKey - 当前页对应的 key，会给对应链接加上 .is-active
 *
 * 响应式：≥769px 横向平铺；≤768px 折叠为汉堡菜单（点击展开，点链接 / Esc / 旋转回桌面端时收起）。
 * 交互在组件内部自绑——render() 只返回 DOM、不返回实例，外部拿不到实例也绑不了事件。
 */
export class Navbar {
  constructor(options = {}) {
    this.brand = options.brand || '书阁园';
    this.links = options.links || [];
    this.activeKey = options.activeKey || '';
  }

  render() {
    const brandObj =
      typeof this.brand === 'string' ? { text: this.brand, href: '/' } : this.brand;

    const nav = document.createElement('nav');
    nav.className = 'navbar';
    nav.innerHTML = `
      <div class="container navbar__inner">
        <a href="${brandObj.href}" class="navbar__brand">${brandObj.text}</a>

        <button
          type="button"
          class="navbar__toggle"
          aria-label="打开菜单"
          aria-expanded="false"
          aria-controls="navbar-menu"
        >
          <span class="navbar__bars" aria-hidden="true">
            <span></span><span></span><span></span>
          </span>
        </button>

        <div class="navbar__menu" id="navbar-menu">
          <nav class="navbar__links">
            ${this.links
              .map((l) => {
                const active = this.activeKey && l.key === this.activeKey ? ' is-active' : '';
                return `<a href="${l.href}" class="navbar__link${active}">${l.text}</a>`;
              })
              .join('')}
          </nav>
        </div>
      </div>
    `;

    this.bindToggle(nav);
    return nav;
  }

  /** 汉堡菜单交互 */
  bindToggle(nav) {
    const btn = nav.querySelector('.navbar__toggle');
    const menu = nav.querySelector('.navbar__menu');
    if (!btn || !menu) return;

    const setOpen = (open) => {
      nav.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
      btn.setAttribute('aria-label', open ? '关闭菜单' : '打开菜单');
    };

    btn.addEventListener('click', () => {
      setOpen(!nav.classList.contains('is-open'));
    });

    // 点任意链接后收起（同页 hash 跳转也要收起）
    menu.addEventListener('click', (e) => {
      if (e.target.closest('.navbar__link')) setOpen(false);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        setOpen(false);
        btn.focus();
      }
    });

    // 旋转回桌面端时清掉展开态，避免 is-open 残留影响横向布局
    window.addEventListener('resize', () => {
      if (window.innerWidth > 768) setOpen(false);
    });
  }
}